module.exports = __webpack_public_path__ + "6669950f0d48dcab2a6fe7bd8974259d.pdf";